<template>
  <div v-if="visible" class="policy-accardion policy-accardion-active">
    <div v-on:click="vis = !vis" class="policy-accardion-header dropdown-div">
      <div class="policy-accardion-title">{{ head }}</div>
      <img
        v-if="!vis"
        src="@/profile/assets/icons/arrow-bottom.svg" alt="arrow-bottom" class="dropdown-img"
      >
      <img
        v-if="vis"
        src="@/profile/assets/icons/arrow-top.svg" alt="arrow-top" class="dropdown-img"
      >
    </div>
    <div v-if="vis" class="accardion-content accardion-content-active">
      <!--Заголовки-->
      <div v-if="type === 'isz'" class="policy-accardion-items-header">
        <div class="policy-accardion-items-title" style="width: 50%;">Дата наблюдения</div>
        <div class="policy-accardion-items-title" style="width: 50%;">{{ isz_head }}</div>
      </div>
      <div v-if="type === 'isz_3'" class="policy-accardion-items-header">
        <div class="policy-accardion-items-title" style="width: 33%;">Сумма ДИД <br>(начислено в {{ currencyType }})
        </div>
        <div class="policy-accardion-items-title" style="width: 33%;">Сумма гарантии <br>(начислено в {{ currencyType
          }})
        </div>
        <div class="policy-accardion-items-title" style="width: 33%;">Итого ДИД <br>(начислено в {{ currencyType }})*
        </div>
      </div>
      <div v-if="type === 'nszbd'" class="policy-accardion-items-header">
        <div class="policy-accardion-items-title" style="width: 33%;">Страховой риск</div>
        <div class="policy-accardion-items-title" style="width: 33%;">Дата начисления</div>
        <div class="policy-accardion-items-title" style="width: 33%;">Сумма к выплате в {{ currencyType }}*</div>
      </div>

      <!--      Для НСЖ с Дид данные и заголовки вместе-->
      <div v-if="type === 'nsz'" class="policy-accardion-items-header">
        <div class="policy-accardion-items-title" style="width: 50%; padding: 5px; padding-top: 20px;">Начисление дохода
          осуществляется в соответствии с условиями договора и правил страхования
        </div>
        <div style="width: 50%; padding: 5px;">
          <div class="policy-accardion-items-title" style="width: 100%;">{{ nsz_head }}</div>
          <div class="policy-accardion-items-text" style="width: 100%; text-align: center;">{{ bonus_show }}</div>
        </div>
      </div>

      <!--Данные-->
      <div v-if="type === 'isz'">
        <div v-for="(item, key) in bonuses" :key="key" class="policy-accardion-items">
          <div class="policy-accardion-items-text" style="width: 50%;">{{ item.fix_date }}</div>
          <div class="policy-accardion-items-text help" style="width: 50%;">
            {{ item.pay_amount !== undefined ? item.pay_amount : item.bonus_amount }}
          </div>
        </div>
      </div>
      <div v-if="type === 'isz_3'">
        <div v-for="(item, key) in bonuses" :key="key" class="policy-accardion-items">
          <div class="policy-accardion-items-text" style="width: 33%;">
            {{ item.pay_amount !== undefined ? item.pay_amount : item.bonus_amount }}
          </div>
          <div class="policy-accardion-items-text" style="width: 33%;">{{ risk_amount }}</div>
          <div class="policy-accardion-items-text" style="width: 33%; text-align: center;">
            {{ item.pay_amount !== undefined ? Number(item.pay_amount) + Number(risk_amount) : Number(item.bonus_amount) + Number(risk_amount)
            }}
          </div>
        </div>
      </div>
      <div v-if="type === 'nszbd'">
        <div v-for="(item, key) in risk_to_show" :key="key" class="policy-accardion-items">
          <div class="policy-accardion-items-text" style="width: 33%;">{{ item.risk_name }}</div>
          <div class="policy-accardion-items-text" style="width: 33%;">{{ item.maturity_date }}</div>
          <div class="policy-accardion-items-text" style="width: 33%;">{{ item.amount }}</div>
        </div>
      </div>

      <div class="policy-accardion-items-title mt-5">
        *Без учета НДФЛ (если применимо) в соответствии с <a
        href="http://nalog.garant.ru/fns/nk/3d6764d4792cb1a58081f87d8a3ef094/" target="_blank">подп. 2 пункта 1
        ст.213</a> Налогового Кодекса РФ, в редакции Федерального закона №176-ФЗ от 12.07.2024 г.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DidNewComponent",
  data: function() {
    return {
      visible: false,
      vis: true,
      bonuses: [],
      is_bonuses_value: false,
      risks: [],
      pt: "",
      pr: "",
      sp: "",
      view_data: {},
      columns: {},
      head: "",
      has_risk: false,
      type: "isz",
      risk_amount: 0,
      risk_to_show: [],
      nsz_head: "",
      isz_head: "",
      begin_date: "",
      bonus_show: 0,
      pay_sum: 0,
      insurance_amount: 0
    };
  },
  computed: {
    currencyType() {
      if (this.risks[0].currency === "usd") {
        return "$";
      }
      if (this.risks[0].currency === "eur") {
        return "€";
      }
      return "руб.";
    }
  },
  async mounted() {
    await this.getContractBonuses();
    if (this.pt === "isz") {
      this.head = "Начисленный инвестиционный доход";
      let d = new Date(this.begin_date), dd = new Date("01.05.2022");
      if (d < dd) {
        if (this.bonuses) {
          if (this.bonuses[0].status === "Предварительный" || this.bonuses[0].status === "Расчетный") {
            this.bonuses[0].bonus_amount = 0;
          }
        }
      }
      this.hasRiskIsz();
      if (this.has_risk) {
        this.type = "isz_3";
        this.visible = true;
        if (!this.bonuses) {
          this.bonuses = [];
          this.bonuses.push({ bonus_amount: 0 });
        }
      } else {
        if (this.bonuses) {
          if (this.pr === "ps" || this.pr === "ps+" || this.pr === "ps_2.0" || this.pr === "mb") {
            this.isz_head = `Сумма ДИД с учетом дивидендов (начислено в ${this.currencyType})*`;
          } else {
            this.isz_head = `Сумма ДИД (начислено в ${this.currencyType})*`;
          }

          this.view_data = this.bonuses;
          this.visible = true;
        }
      }
    } else {
      this.hasRiskNsz();
      this.hasBonusNSZ();
      this.getNznHead();
      if (this.bonuses || this.has_risk) {
        this.visible = true;
      }
    }
  },
  methods: {
    async getContractBonuses() {
      const contract = this.$myApp.contract.get();
      const api = await this.$api2.get({
        action: "get-contract-bonuses",
        object: "cpa",
        agreement_id: this.$route.params.token ? this.$route.params.id : contract.agreement_id,
        contract_id: this.$route.params.token ? this.$route.params.id : contract.contract_id,
        version_id: this.$route.params.token ? this.$route.params.id : contract.version_id,
        cover_id: this.$route.params.token ? this.$route.params.id : contract.cover_id,
        document_id: this.$route.params.token ? this.$route.params.id : contract.document_id,
        token: this.$route.params.token ? this.$route.params.token : this.$myApp.token.get()
      });
      if (api.success) {
        if (api.data.bonuses.data?.error.code > 0) {
          if (api.data.bonuses.data?.error.code === 777) {
            let fix_date = new Date(),
              month = String(fix_date.getMonth() + 1);
            if (month.length === 1) {
              month = "0" + month;
            }
            this.bonuses.push({
              bonus_amount: 0,
              fix_date: fix_date.getDate() + "." + month + "." + fix_date.getFullYear(),
              status: ""
            });
          } else {
            this.bonuses = false;
          }
        } else {
          if (api.data.bonuses.data?.data?.values?.length === 0) {
            this.bonuses = false;
          } else if (Array.isArray(api.data.bonuses.data?.data.values)) {
            this.bonuses = api.data.bonuses.data.data.values;
          } else {
            this.bonuses.push(api.data.bonuses.data?.data.values);
          }
        }

        await this.getContractRisks();
        await this.getContractDetails();
        await this.getContractPaysSum();

      }
    },
    async getContractRisks() {
      const contract = this.$myApp.contract.get();
      const api = await this.$api2.get({
        action: "get-contract-bonuses-risks",
        object: "cpa",
        agreement_id: this.$route.params.token ? this.$route.params.id : contract.agreement_id,
        contract_id: this.$route.params.token ? this.$route.params.id : contract.contract_id,
        version_id: this.$route.params.token ? this.$route.params.id : contract.version_id,
        cover_id: this.$route.params.token ? this.$route.params.id : contract.cover_id,
        document_id: this.$route.params.token ? this.$route.params.id : contract.document_id,
        token: this.$route.params.token ? this.$route.params.token : this.$myApp.token.get()
      });
      if (api.success) {
        if (api.data.risks.length > 0) {
          this.risks = api.data.risks;
        }
      }
    },
    async getContractPaysSum() {
      const contract = this.$myApp.contract.get();
      const api = await this.$api2.get({
        action: "get-contract-bonuses-pays",
        object: "cpa",
        agreement_id: this.$route.params.token ? this.$route.params.id : contract.agreement_id,
        contract_id: this.$route.params.token ? this.$route.params.id : contract.contract_id,
        version_id: this.$route.params.token ? this.$route.params.id : contract.version_id,
        cover_id: this.$route.params.token ? this.$route.params.id : contract.cover_id,
        document_id: this.$route.params.token ? this.$route.params.id : contract.document_id,
        token: this.$route.params.token ? this.$route.params.token : this.$myApp.token.get()
      });
      if (api.success) {
        this.pay_sum = Number(api.data.bonuses_pays);
        // console.log(`getContractPaysSum`, this.pay_sum);
      }
    },
    async getContractDetails() {
      const contract = this.$myApp.contract.get();
      const api = await this.$api2.get({
        action: "get-contract-details",
        object: "cpa",
        agreement_id: this.$route.params.token ? this.$route.params.id : contract.agreement_id,
        contract_id: this.$route.params.token ? this.$route.params.id : contract.contract_id,
        version_id: this.$route.params.token ? this.$route.params.id : contract.version_id,
        cover_id: this.$route.params.token ? this.$route.params.id : contract.cover_id,
        document_id: this.$route.params.token ? this.$route.params.id : contract.document_id,
        token: this.$route.params.token ? this.$route.params.token : this.$myApp.token.get()
      });
      if (api.success) {
        this.pt = api.data.details.tech.pt.value;
        this.pr = api.data.details.tech.pr.value;
        this.sp = api.data.details.tech.sub.value;
        this.begin_date = api.data.details.info.begin_date.value;
        this.pay_sum = Number(api.data.details.tech.insurance_amount.value);
        // console.log(`getContractDetails`, this.pay_sum);
        // this.insurance_amount = parseInt(api.data.details.info.insurance_amount.value.replaceAll(/[^0-9.]/g, ""));
        this.insurance_amount = Number(api.data.details.tech.insurance_amount.value);
        // console.log(`getContractDetails`, this.insurance_amount);
      }
    },
    hasRiskIsz() {
      for (let i = 0; i < this.risks.length; i++) {
        if (this.risks[i].risk_id === "11042") {
          this.risk_amount = this.risks[i].amount;
          if (this.risks[i].amount > 100) {
            this.has_risk = true;
          }
        }
      }
    },
    hasRiskNsz() {
      // console.log(`hasRiskNsz`, this.risks);
      if (this.risks.length === 0) {
        return;
      }
      for (let i in this.risks) {
        if (this.risks[i].risk_id === "11042") {
          this.has_risk = true;
          this.risk_amount = this.risks[i].pay_amount;
          this.risk_to_show.push(this.risks[i]);
        }
      }
      if (this.has_risk) {
        this.risk_to_show.sort((a, b) => new Date(a.maturity_date.split(".").reverse().join("-")) > new Date(b.maturity_date.split(".").reverse().join("-")) ? 1 : -1);
        // this.risk_to_show.sort((a, b) => {new Date(a.maturity_date) - new Date(b.maturity_date)});
      }
    },
    hasBonusNSZ() {
      if (Array.isArray(this.bonuses)) {
        for (let i = 0; i < this.bonuses.length; i++) {
          if (this.bonuses[i]?.bonus_amount !== null) {
            this.is_bonuses_value = true;
          }
        }
      } else {
        if (this.bonuses.bonus_amount !== null) {
          this.is_bonuses_value = true;
        }
      }

      if (!this.is_bonuses_value) {
        this.bonuses = false;
      }
    },
    getNznHead() {
      let nsz_a = ["1", "4", "15"];
      let nsz_c = ["2", "3"];
      let nsz_fi = ["6", "14"];
      this.head = "Доход";
      this.type = "nsz";
      if (this.pr === "ic") {
        this.nsz_head = `Сумма накоплений за период с учетом индексации (начислено в ${this.currencyType})*`;
      } else if (this.pr === "gp") {
        if (nsz_a.includes(this.sp) || nsz_c.includes(this.sp)) {
          // console.log(`getNznHead this.pay_sum =`, this.pay_sum);
          // this.insurance_amount вместо this.pay_sum по задаче 116106
          this.bonus_show = this.bonuses ? this.insurance_amount + Number(this.bonuses[this.bonuses.length - 1].bonus_amount) : this.insurance_amount;
          this.bonus_show = this.bonus_show.toFixed(2);
          // console.log(`getNznHead this.bonus_show =`, this.bonus_show);
          this.nsz_head = `Страховая сумма и дополнительный инвестиционный доход (${this.currencyType})*`;
          this.has_risk = true;
        } else if (nsz_fi.includes(this.sp)) {
          if (this.risk_to_show.length === 0) {
            this.bonuses = false;
          }
          this.type = "nszbd";
          this.head = "Доход по программе";
        } else {
          if (this.has_risk) {
            if (this.risk_to_show.length === 0) {
              this.bonuses = false;
            }
            this.type = "nszbd";
            this.head = "Доход по программе";
          } else {
            this.type = "nsz";
            this.nsz_head = `Совокупный дополнительный инвестиционный доход + сумма накоплений за период (начислено в ${this.currencyType})*`;
            let show_sum = 0;
            // for (let i in this.risks) {
            //   if (this.risks[i].risk_id === "11001") {
            //     risk_amount += Number(this.risks[i].amount);
            //   } else if (this.risks[i].risk_id === "11002") {
            //     risk_amount += Number(this.risks[i].amount);
            //   } else if (this.risks[i].risk_id === "11003") {
            //     risk_amount += Number(this.risks[i].amount);
            //   } else if (this.risks[i].risk_id === "11004") {
            //     risk_amount += Number(this.risks[i].amount);
            //   } else if (this.risks[i].risk_id === "11021") {
            //     risk_amount += Number(this.risks[i].amount);
            //   }
            // }
            if (this.insurance_amount >= this.pay_sum) {
              show_sum = this.insurance_amount - this.pay_sum;
            } else {
              show_sum = 0;
            }
            if (this.bonuses) {
              this.bonus_show = Number(this.bonuses[this.bonuses.length - 1].bonus_amount) + show_sum;
            } else {
              this.bonus_show = show_sum;
            }
            this.has_risk = true;
          }
        }
      } else if (this.pr === "fi") {
        this.type = "nszbd";
        this.head = "Доход по программе";
      }
    }
  }
};
</script>

<style scoped>
.policy-accardion-items-text {
  padding: 0 15px;
  font-weight: 700 !important;
}

.policy-accardion-items-title {
  font-weight: 500 !important;
}
</style>